import { Component, OnInit, inject } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { Router } from '@angular/router';

@Component({
    selector: 'app-auth-callback',
    template: '<p>Bezig met inloggen...</p>'
})
export class AuthCallbackComponent implements OnInit {
  private readonly oauthService = inject(OAuthService);
  private readonly router = inject(Router);


  async ngOnInit() {
    await this.oauthService.loadDiscoveryDocument();
    await this.oauthService.tryLoginCodeFlow();

    if (this.oauthService.hasValidAccessToken()) {
      this.router.navigateByUrl('/');
    } else {
      console.error('Inloggen mislukt');
    }
  }
}
